import React from 'react';

export class AppErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="app-loading" role="alert">
      <h1>页面暂时无法显示</h1>
      <p>请重新加载以获取最新导航。</p>
      <button type="button" onClick={() => {
        try { localStorage.removeItem('muyuan_config_cache'); } catch { /* Storage may be unavailable. */ }
        window.location.reload();
      }}>重新加载</button>
    </main>;
  }
}
